import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConstantsService } from './constants.service';

export interface UserProfile {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  avatarUrl?: string;
  createdAt: string;
  lastLogin?: string;
  isActive: boolean;
  marketingConsent?: boolean;
}

export interface UpdateProfileRequest {
  firstName: string;
  lastName: string;
  marketingConsent?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(private http: HttpClient, private constants:ConstantsService) {}

  /**
   * Get current user's profile from backend API
   */
  getUserProfile(): Observable<UserProfile> {
    return this.http.get<UserProfile>(this.constants.api_profile);
  }

  /**
   * Update current user's profile via backend API
   */
  updateUserProfile(profileData: UpdateProfileRequest): Observable<UserProfile> {
    return this.http.put<UserProfile>(this.constants.api_profile, profileData);
  }

  /**
   * Check if user needs to complete their profile
   */
  needsProfileCompletion(profile: UserProfile): boolean {
    return !profile.firstName || !profile.lastName;
  }
}
